import React from 'react'

import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'

import { Button, Flex } from 'antd'

type Props = {
  tickets: number[]
  buttonName: string
}

export const TicketsModal: React.FC<Props> = ({ tickets, buttonName }) => {
  const [isVisible, setVisible] = React.useState(false)

  return (
    <>
      <Button onClick={() => setVisible(true)} type="primary">
        {buttonName}
      </Button>
      <CModal visible={isVisible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>Tickets</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <Flex wrap="wrap" gap="small">
            {tickets.map((ticket, index) => (
              <div key={index}>{ticket}</div>
            ))}
          </Flex>
        </CModalBody>
      </CModal>
    </>
  )
}
